<template>
<div class="sidenav-container">
  <div
    v-if="show"
    class="sidenav-backdrop"
    @click="$emit('close')" />
  <transition name="slide-side">
    <div
      v-if="show"
      class="sidenav"
    >
      <span @click="$emit('close')">
        <LoginMobile
          :isLogged="isLogged"
          :userName="userName"
          :lastLogin="lastLogin" />
      </span>
      <span @click="$emit('close')">
        <SiteMobile />
      </span>
      <span v-if="isLogged" class="logged-menu" @click="$emit('close')">
        <LoggedMobile />
      </span>
      <span
        v-if="isLogged"
        class="logout logout--text logout--m"
        @click="signOut">
        Cerrar sesión
      </span>
    </div>
  </transition>
</div>
</template>

<script>
import LoginMobile from '@/components/Navigation/Menu/Mobile/LoginMobile'
import SiteMobile from '@/components/Navigation/Menu/Mobile/SiteMobile'
import LoggedMobile from '@/components/Navigation/Menu/Mobile/LoggedMobile'

import { mapState } from 'vuex'

export default {
  name: 'TheSideNav',
  components: {
    LoginMobile,
    SiteMobile,
    LoggedMobile
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: mapState({
    isLogged: state => state.alive,
    userName: state => state.userName,
    lastLogin: state => state.lastLogin
  }),
  methods: {
    signOut: function () {
      this.$store.dispatch('signout')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidenav-container {
  height: 100%;
  width: 100%;
}

.sidenav-backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
}

.sidenav {
  height: 100%;
  width: 300px;
  background-color: $midnight-blue;
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  padding: 30px;
  overflow-y: scroll;
}

.slide-side-enter-active,
.slide-side-leave-active {
  transition: all 0.3s ease-out;
}
.slide-side-enter,
.slide-side-leave-to {
  transform: translateX(-100%);
}

.logged-menu {
  display: block;
  border-top: 1px solid #596875;
}

.logout {
  display: block;
  cursor: pointer;
}

.logout--m {
  margin: 4em 0 .5em 0;
}
.logout--text {
  color:white;
  text-align: center;
  font-weight: bold;
  font-size: .7em;
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation/TheSideNav.vue